import esriId from "@arcgis/core/identity/IdentityManager";
import { useCallback, useEffect, useState } from "react";
import { useGetArcgisToken } from "../../api";
import "./styles.css";

function SamsynMap({ locationId, latitude, longitude, serviceType, layerName }) {
    const [finalUrl, setFinalUrl] = useState("");

    const { data, isLoading, isSuccess, isError } = useGetArcgisToken({
        onSuccess: (data) => {
            esriId.registerToken({
                server: "https://www.arcgis.com/sharing/rest",
                token: data.accessToken,
            });
        },
    });

    const getBaseUrl = useCallback(() => {
        let serviceMapLayer = "";

        if (layerName && typeof layerName === "string" && layerName.length > 0) {
            return `https://gardlist.samsyn.is/dynamicsSvaedi/?layer=${layerName}&edit=false`;
        }

        switch (serviceType) {
            case "Vetrarverk":
                serviceMapLayer = "mokstur";
                break;
            case "Sópur":
                serviceMapLayer = "sopur";
                break;
            case "Hreinsun":
                serviceMapLayer = "hreinsun";
                break;
            case "Klipping":
                serviceMapLayer = "klipping";
                break;
            case "Sláttur":
                serviceMapLayer = "einkaslattur";
                break;
            case "Jólaseríur":
            case "Jólaseríur laga":
            case "Jólaseríur leiga":
            case "Jólaseríur taka niður":
                serviceMapLayer = "jolaseriur";
                break;
            default:
                serviceMapLayer = "gardyrkja";
                break;
        }
        return `https://gardlist.samsyn.is/dynamicsSvaedi/?layer=${serviceMapLayer}&edit=false`;
    }, [serviceType, layerName]);

    useEffect(() => {
        if (!data || !isSuccess) return;
        const baseUrl = getBaseUrl();

        setFinalUrl(`${baseUrl}&lat=${latitude}&lon=${longitude}&quid=${locationId}&token=${data.accessToken}`);
    }, [data, isSuccess, latitude, longitude, locationId, getBaseUrl]);

    if (isLoading) {
        return <>loading ...</>;
    }
    if (isError) {
        return <>error</>;
    }
    if (!locationId) {
        return <div>Engar upplýsingar um hnit</div>;
    }

    return (
        <div id="viewDiv" style={{ height: "100%" }}>
            <div>
                <iframe title="Samsyn map" src={finalUrl} width="100%" height="400px" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex="0" />
            </div>
        </div>
    );
}

export default SamsynMap;
